module.exports = __webpack_public_path__ + "static/media/meb_logo.06114282.jpeg";